class PasswordInput extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['password', 'trigger']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.onPasswordReveal.bind(this),
    )
  }

  onPasswordReveal () {
    const passwordElement = this.password

    if (passwordElement.type === 'password') {
      passwordElement.type = 'text'
    } else {
      passwordElement.type = 'password'
    }
  }

  get password () {
    return this.els.password.element
  }
}

if (!customElements.get('password-input')) {
  customElements.define('password-input', PasswordInput)
}
